<template>
  <HeroSection title="Career" class="bg-slate-800" bg-src="/images/audi-wheel.webp" />

  <section class="container py-10">
    <p class="text-lg text-center">Do you want to be a part of our team?</p>
   <h1>Join our team of professional English-speaking local drivers</h1>

<p>We're looking to expand our team of skilled, bilingual drivers at Driveczech - Your Personal Driver. As part of our team, you will:</p>

<ul>
  <li>Provide your own vehicle (not older than 5 years) to use for transporting passengers</li>
  <li>Earn 80% of the fare for each ride you complete</li>
  <li>Need to be fluent in both Czech and English to communicate effectively with customers</li>
</ul>

<p>To apply, please send us your CV along with one interior and one exterior photo of your vehicle. Tell us also something about you and your experience in limousine service sector. We'd love to hear from you and welcome you to our growing team. Our CFO Martin Zada will contact you back.</p>

<p><strong>Important notice: </strong>We have enough drivers in Prague for now. Please contact us in March 2025 if we are hiring again.</p>
    <p class="text-center">
      <UButton to="mailto:info@driveczech.com?subject=Career" leading-icon="i-heroicons-envelope">Apply</UButton>
    </p>
  </section>

  <ContentMission />

  <Footer />
</template>
